// extracted by mini-css-extract-plugin
export default {"filter_app":"filter_filter_app__lQc-0","filter_Form":"filter_filter_Form__aU7gp","Detail_div":"filter_Detail_div__Q+JMb"};